/*
 * Granu + Zapiet: trava do botão "Finalizar a compra" até escolher método, data e horário.
 * Funciona na página /cart e na gaveta do carrinho:
 * - botão e formulário são buscados na hora (sobrevivem ao morph do Horizon);
 * - o estado escolhido fica em memória e é reaplicado depois de cada cart:update;
 * - espera o window.ZapietEvent existir antes de registrar os listeners.
 */
(function () {
  if (window.__granuEntregaApp) return;
  window.__granuEntregaApp = true;

  var estado = { liberado: false, tipo: '', data: '', hora: '' };
  var salvandoPropriedades = false;
  var limpezaFeita = false;

  function botaoCheckout() {
    return document.querySelector('.cart__checkout-button.button');
  }

  function formCarrinho() {
    return document.querySelector('#cart-form');
  }

  function desabilitaBotao() {
    var b = botaoCheckout();
    if (!b) return;
    b.setAttribute('disabled', 'disabled');
    b.style.opacity = '0.5';
    b.style.cursor = 'not-allowed';
  }

  function habilitaBotao() {
    var b = botaoCheckout();
    if (!b) return;
    b.removeAttribute('disabled');
    b.style.opacity = '';
    b.style.cursor = '';
  }

  /* Fonte de verdade: os eventos do Zapiet (checkoutEnabled / selected_method / disableCheckout).
     Não consultamos Zapiet.Widget.checkoutEnabled() aqui: ao trocar de método ele ainda devolve o
     valor do método anterior por um instante, o que liberaria o botão indevidamente. */
  function liberadoAgora() {
    return estado.liberado;
  }

  function aplicarEstado() {
    if (liberadoAgora()) habilitaBotao();
    else desabilitaBotao();
  }

  function limparEscolha() {
    estado.tipo = '';
    estado.data = '';
    estado.hora = '';
  }

  function formatarData(isoDate) {
    if (!isoDate) return '';
    var partes = isoDate.split('-');
    if (partes.length !== 3) return isoDate;
    return partes[2] + '/' + partes[1] + '/' + partes[0];
  }

  function limparPropriedadesAntigas() {
    if (limpezaFeita) return;
    limpezaFeita = true;
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items.length) return;

        var primeiraLinha = cart.items[0];

        if (
          primeiraLinha.properties &&
          (primeiraLinha.properties['Tipo de Entrega'] ||
            primeiraLinha.properties['Data de Entrega'] ||
            primeiraLinha.properties['Horário de Entrega'])
        ) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: primeiraLinha.key,
              quantity: primeiraLinha.quantity,
              properties: {
                'Tipo de Entrega': '',
                'Data de Entrega': '',
                'Horário de Entrega': '',
              },
            }),
          })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              console.log('Propriedades antigas removidas');
              return data;
            });
        }
      })
      .catch(function (err) {
        limpezaFeita = false;
        console.error('Erro ao limpar propriedades:', err);
      });
  }

  function salvarProperties(tipo, data, hora) {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items.length) {
          console.warn('Carrinho vazio, não foi possível salvar propriedades.');
          return;
        }

        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: cart.items[0].key,
            quantity: cart.items[0].quantity,
            properties: {
              'Tipo de Entrega': tipo || '',
              'Data de Entrega': data || '',
              'Horário de Entrega': hora || '',
            },
          }),
        })
          .then(function (r) { return r.json(); })
          .then(function (resp) {
            console.log('Propriedades salvas no primeiro item:', { tipo: tipo, data: data, hora: hora });
            return resp;
          });
      });
  }

  /* Submit do carrinho (página ou gaveta): salva as propriedades antes de ir ao checkout. */
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.id !== 'cart-form') return;
      var submitter = e.submitter;
      if (submitter && submitter.id !== 'checkout' && submitter.getAttribute('name') !== 'checkout') return;

      if (!liberadoAgora()) {
        e.preventDefault();
        aplicarEstado();
        return;
      }

      if ((estado.tipo || estado.data || estado.hora) && !salvandoPropriedades) {
        e.preventDefault();
        salvandoPropriedades = true;

        salvarProperties(estado.tipo, estado.data, estado.hora)
          .then(function () {
            var f = formCarrinho();
            if (window.ZapietCheckoutUrl && f.getAttribute('action').indexOf('/checkout') === -1) {
              f.setAttribute('action', window.ZapietCheckoutUrl);
            }
            f.submit();
          })
          .catch(function (err) {
            console.error('Erro ao processar checkout:', err);
            salvandoPropriedades = false;
            alert('Erro ao processar pedido. Por favor, tente novamente.');
          });
      }
    },
    true
  );

  function registrarZapiet() {
    window.ZapietEvent.listen('checkoutEnabled', function (params) {
      if (params.method === 'shipping') {
        estado.liberado = true;
        limparEscolha();
      } else if (params.time && params.time.length > 0) {
        estado.liberado = true;
        estado.tipo = params.method === 'delivery' ? 'Entrega' : 'Retirada';
        estado.data = formatarData(params.date);
        estado.hora = params.time;

        console.log('Dados do Zapiet prontos para checkout:', {
          tipo: estado.tipo,
          data: estado.data,
          hora: estado.hora,
        });
      } else {
        estado.liberado = false;
        limparEscolha();
      }
      aplicarEstado();
    });

    window.ZapietEvent.listen('selected_method', function (checkout_method) {
      switch (checkout_method) {
        case 'pickup':
        case 'delivery':
          estado.liberado = false;
          limparEscolha();
          break;
        case 'shipping':
          estado.liberado = true;
          limparEscolha();
          break;
      }
      aplicarEstado();
    });

    /* O Zapiet trava o checkout e reinicia o widget depois de qualquer /cart/add ou /cart/change. */
    window.ZapietEvent.listen('disableCheckout', function () {
      estado.liberado = false;
      limparEscolha();
      aplicarEstado();
    });

    window.ZapietEvent.listen('delivery.timepicker.rendered', function () {
      if (window.Zapiet.Widget.checkoutEnabled && window.Zapiet.Widget.checkoutEnabled().time) {
        estado.liberado = true;
        aplicarEstado();
      }
    });
  }

  /* Depois de cada atualização do carrinho o Horizon redesenha o botão sem o disabled: reaplica o estado. */
  function reaplicarDepoisDoRedesenho() {
    var n = 0;
    var timer = setInterval(function () {
      aplicarEstado();
      if (++n >= 20) clearInterval(timer);
    }, 150);
  }
  document.addEventListener('cart:update', reaplicarDepoisDoRedesenho);
  document.addEventListener('granu:zapiet-gaveta-atualizada', aplicarEstado);

  /* Gaveta aberta: aplica a trava e limpa propriedades antigas (uma vez por página). */
  document.addEventListener(
    'dialog:open',
    function (e) {
      if (e.target && e.target.matches && e.target.matches('cart-drawer-component')) {
        aplicarEstado();
        limparPropriedadesAntigas();
      }
    },
    true
  );

  function iniciar() {
    if (window.location.pathname.indexOf('/cart') === 0) limparPropriedadesAntigas();
    aplicarEstado();

    var tentativas = 0;
    (function esperarZapiet() {
      if (window.ZapietEvent && typeof window.ZapietEvent.listen === 'function') {
        registrarZapiet();
        return;
      }
      if (++tentativas > 100) {
        console.warn('Zapiet não carregou; botão de finalizar permanece travado.');
        return;
      }
      setTimeout(esperarZapiet, 100);
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
